import React from 'react'
import classNames from 'classnames'

interface PointInsufficientModalProps {
  isOpen: boolean
  onClose: () => void
  currentPoint: number
  requiredPoint: number
}

export const PointInsufficientModal: React.FC<PointInsufficientModalProps> = ({
  isOpen,
  onClose,
  currentPoint,
  requiredPoint,
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleChargePoints = () => {
    // 새 창에서 충전 페이지 열기
    window.open(
      `${process.env.REACT_APP_URL}/price/style-room?payment=true&close=true&selectType=fashion`,
      '_blank',
    )
    onClose()
  }

  const shortageAmount = requiredPoint - currentPoint

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div
        className={classNames(
          'overflow-hidden rounded-[20px] bg-white shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)]',
          'mx-4 w-[335px]', // 모바일/데스크톱 공통 335px 폭
        )}
      >
        {/* 상단 메시지 영역 */}
        <div className="flex flex-col items-center justify-center gap-6 px-5 py-8">
          {/* 제목 */}
          <div className="text-center">
            <p className="text-center text-[18px] font-bold leading-[1.44] text-[#222222]">
              💰 캐시가 부족해요!
            </p>
          </div>

          {/* 포인트 정보 */}
          <div className="w-full rounded-[10px] bg-[#F6F8FB] p-4">
            <div className="mb-2 flex items-center justify-between">
              <span className="text-[14px] text-[#8F929B]">현재 보유 캐시</span>
              <span className="text-[14px] font-bold text-[#222222]">
                {currentPoint.toLocaleString()} 캐시
              </span>
            </div>
            <div className="mb-2 flex items-center justify-between">
              <span className="text-[14px] text-[#8F929B]">필요한 캐시</span>
              <span className="text-[14px] font-bold text-[#222222]">
                {requiredPoint.toLocaleString()} 캐시
              </span>
            </div>
            <hr className="my-2 border-[#E5E8EB]" />
            <div className="flex items-center justify-between">
              <span className="text-[14px] font-bold text-[#FF4444]">
                부족한 캐시
              </span>
              <span className="text-[14px] font-bold text-[#FF4444]">
                {shortageAmount.toLocaleString()} 캐시
              </span>
            </div>
          </div>

          {/* 설명 */}
          <div className="w-full">
            <p className="text-center text-[14px] leading-[1.57] text-[#8F929B]">
              스타일 샷 세트 생성을 위해
              <br />
              캐시를 충전해주세요!
            </p>
          </div>
        </div>

        {/* 하단 버튼 영역 */}
        <div className="flex">
          <button
            onClick={onClose}
            className="flex-1 bg-[#F6F8FB] px-[10px] py-[19px] text-[14px] font-bold text-[#8F929B] transition-colors hover:bg-[#E5E8EB]"
          >
            취소
          </button>
          <button
            onClick={handleChargePoints}
            className="flex-1 bg-[#00B7B9] px-[10px] py-[19px] text-[14px] font-bold text-white transition-colors hover:bg-[#009999]"
          >
            충전하러 가기
          </button>
        </div>
      </div>
    </div>
  )
}
